import { CheckIcon, ExcludeIcon, SlideshowIcon } from "@phosphor-icons/react";
import { useOne, useTranslate } from "@refinedev/core";
import { Flex } from "antd";
import { useAntTheme } from "hooks/useAntTheme/";
import { BrandKit, MediaProjectResponse } from "pages/media/types";
import { useState } from "react";
import { TransitionPreview } from "../TransitionPreview";
import { radius } from "@libertify/ui";

export function ProjectSettingsFormTransitions<T>(props: {
  name: string;
  valuePropName: string;
  value: T;
  initialValue?: T;
  onChange: (value: T) => void;
  loading?: boolean;
  project?: MediaProjectResponse;
}) {
  const t = useTranslate();
  const { theme } = useAntTheme();

  const handleChange = (value: string) => {
    setReloadTrigger((prev) => !prev);
    props.onChange(value as T);
  };

  const [reloadTrigger, setReloadTrigger] = useState(false);

  const { data } = useOne<BrandKit>({
    resource: `media/${props.project?.organization_id}/brand_kits`,
    id: props.project?.settings.brand_kit_id ?? undefined,
    queryOptions: {
      enabled:
        !!props.project?.organization_id &&
        !!props.project?.settings.brand_kit_id,
    },
  });

  const options = [
    {
      label: (
        <Flex vertical align="center">
          <Flex align="center" gap={10}>
            <SlideshowIcon size={40} weight="duotone" />
            {t("projects.components.ProjectSettings.NoTransition")}
          </Flex>
          <TransitionPreview
            brandKit={data?.data}
            hasTransition={false}
            reloadTrigger={reloadTrigger}
          />
        </Flex>
      ),
      value: "NoTransition",
    },
    {
      label: (
        <Flex vertical align="center">
          <Flex align="center" gap={10}>
            <ExcludeIcon size={40} weight="duotone" />
            {t("projects.components.ProjectSettings.Basic")}
          </Flex>
          <TransitionPreview
            brandKit={data?.data}
            hasTransition={true}
            reloadTrigger={reloadTrigger}
          />
        </Flex>
      ),
      value: "Basic",
    },
  ];

  return (
    <Flex gap={40} justify="center">
      {options.map((item, index) => {
        return (
          <Flex key={index} style={{ position: "relative" }}>
            {props.value === item.value && (
              <Flex
                align="center"
                justify="center"
                style={{
                  position: "absolute",
                  backgroundColor: theme.colorPrimary,
                  width: 40,
                  height: 40,
                  border: `5px solid ${theme.colorBgElevated}`,
                  borderRadius: radius.circle,
                  color: theme.colorBgElevated,
                  right: -10,
                  top: -10,
                  zIndex: 10,
                }}
              >
                <CheckIcon size={22} />
              </Flex>
            )}
            <Flex
              key={index}
              align="center"
              justify="center"
              style={{
                backgroundColor:
                  props.value === item.value
                    ? theme.colorPrimary
                    : theme.colorBgElevated,
                color:
                  props.value === item.value
                    ? theme.colorBgElevated
                    : theme.colorTextDescription,
                width: 300,
                height: 430,
                borderRadius: radius.box,
                boxShadow: `0 0 10px ${theme.colorBorder}`,
              }}
              onClick={() => handleChange(item.value)}
            >
              {item.label}
            </Flex>
          </Flex>
        );
      })}
    </Flex>
  );
}
